module.exports = __webpack_public_path__ + "img/star-active.cc82c699.svg";